import React from "react"

// redux
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { connect } from "react-redux"
import { useLanguage } from "@languages/index"

const TransactionInfoIndex = (props: any) => {
  const language = useLanguage()
  const languageTexts = { ...language.common }

  return (
    <div className="mx-auto py-20 px-6 max-w-2xl flex flex-col justify-center items-center">
      <h1 className="text-2xl font-bold mb-6">特定商取引法に基づく表記</h1>
      <div className="w-full text-[12px]">
        <table className="w-full border-collapse">
          <tbody>
            {[
              {title: "販売業者", value: "KYOLOOK株式会社"},
              {title: "代表責任者", value: "黒澤 杏香"},
              {title: '所在地', value: '東京都渋谷区神宮前6-28-9 東武ビル6F'},
              {title: '電話番号', value: '03-6892-4018　受付時間：10:00-18:00（土日祝を除く）'},
              {title: 'メールアドレス', value: 'info@kyolook.com'},
              {title: 'ホームページ', value: 'https://kyolook.com'},
              {title: '商品販売価格', value: '各商品ページをご参照ください。'},
              {title: '支払い方法', value: 'クレジットカード決済'},
              {title: '商品引渡し時期', value: '決済後即時'},
              {title: '返品・キャンセル規定', value: 'お客様のご都合による返品・キャンセルは基本的に対応しておりません。\n販売業者の過失による返品・キャンセルについては、メールまたはお電話にてご連絡ください。'},
            ].map((item, idx) => (
              <tr key={idx} className="border border-gray-200">
                <th className="bg-[#E8F4F8] p-2 text-left w-1/3 border border-gray-200">{item.title}</th>
                <td className="p-2 border border-gray-200 whitespace-pre-line">{item.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(TransactionInfoIndex)